import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Label,
  Input,
  FormGroup,
  Form,
  Button,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { directUrl, homePageUrl } from "../../../helpers/Constants";
import axios from "axios";
import { requestApi } from "../../../request-api";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Triangle } from 'react-loader-spinner'
import { clone } from "lodash";

function Approver() {
  let navigate = useNavigate();

  let [calendarValue, setCalenderValue] = useState(new Date());
  let [selectedDate, setSelectedDate] = useState("");
  let [success, setSuccess] = useState(true);
  let [name, setName] = useState("");
  let [contactNumber, setContactNumber] = useState("");
  let [adhaarNumber, setAdhaarNumber] = useState("");
  let [branch, setBranch] = useState([]);
  let [company, setCompany] = useState('');
  let [officeAddress, setOfficeAddress] = useState("");
  let [companyList, setCompanyList] = useState([]);
  const [startDate, setStartDate] = useState('');
  let [state, setState] = useState([]);
  let [branchId, setBranchId] = useState([]);
  let [optionData, setOptionData] = useState([]);
  let [formErrors, setFormErrors] = useState({});
  let [isSubmit, setIsSubmit] = useState(false);
  let [loading, setLoading] = useState(false);
  let string =''
  const successToast = (message) => toast.success(message, {
    position: "bottom-right"
});

const errorToast = (error) => toast.error(error, {
    position: "bottom-right"
});

  useEffect(() => {
    setSelectedDate(
      `${calendarValue.getDate()}/${
        calendarValue.getMonth() + 1
      }/${calendarValue.getFullYear()}`
    );
  }, [calendarValue]);
  const options = optionData;
  useEffect(() => {
    getAllCompany();
   
  }, [success]);
  useEffect(()=>{
    setState({
      searchField: null,
      values: []
    })

  },[])

  const handleChangeSelect = (e) => {

    let newOpts = e;
     string = state.searchField;   
    let leng = e.length -1
    if (e[leng] && e[leng].value === "all") {
      let filteredOptions = clone(options);
     
      filteredOptions = filteredOptions.filter(
        (filteredOption) =>        
          // isIncludingString(string, filteredOption) &&
          !newOpts.includes(filteredOption)
      );
     
      string = null;
      newOpts = newOpts
        .concat(filteredOptions)
        .filter((newOpt) => newOpt.value !== "all");
      }
      console.log("newOpts cmmcmc",newOpts)
       setState({
      searchField: string,
      values: newOpts
    });

    const value = new Array();
    for (let i = 0; i < newOpts.length; i++) {
      value.push(newOpts[i].value);
    }
    console.log("branchId", value);
    setBranchId([{ branch: value }]);


  };

  const onInputChange = (string, {action}) => {
    if (action === "input-change") {
      setState({
        searchField: string
      });
    }
  };
  const filterOption = ( options , string) => {
    if (options.value === "all") {
      return true;
    } else if (string) {
      return options.label.includes(string) || options.value.toString().includes(string);
    } else {
      return true;
    }
  };
  

 

  

  const getAllCompany = async () => {
    try {
      await requestApi("/auditor/company/getCompanyForCompliance", {
        method: "get",
      }).then((data) => {
        setCompanyList(data.data);
        console.log("Response of company  is >>", companyList);

        companyList.map((item) => {
          console.log("list of company", item.company_name);
        });
      });
    } catch (error) {
      console.log("error is ", error);
    }
  };

  const handleCompany = async (e) => {
    setCompany(e)
    // setState({value:null})
    setBranchId([{branch:null}])
    console.log("index of compnay", e,branchId,state);
    try {
      const formData = { company_name: e };
      console.log("company_name formValues", e);

      await requestApi("/auditor/branch/getBranchApproverNull", {
        method: "post",
        body: JSON.stringify({
          company_name: e,
        }),
      }).then((data) => {
        setBranch(data.data);
        let dataoptions =[]
        data.data.forEach((element) => {
          dataoptions.push({ value: element.branch_id, label: element.branch_id });
        });
        if(dataoptions.length > 0)
        {
          dataoptions.push({ value: 'all', label: 'Select all' })
        }
        setOptionData(dataoptions);
        console.log("dataoptions",dataoptions)
      });
    } catch (error) {
      console.log("error is ", error);
    }
  };

  const registerApprover = async () => {
   
      console.debug("sending code");
      requestApi("/auditor/approver/createApprover", {
        method: "post",
        body: JSON.stringify({
          name: name,
          phone_number: contactNumber,
          role_id: 4,
          aadhaar_number: adhaarNumber,
          DOJ: startDate,
          office_address: officeAddress,
          client_list: branchId,
        }),
      }).then((data) => {
        
        if (data.statusCode === 403) {
          errorToast(data.message)
        }
        if (data.statusCode === 200) {
          successToast('Successfully created Approver')
          navigate(`${directUrl}auditor/user-profile`);
        }
      }).catch((error)=>{
        errorToast(error.message)
        console.log(error)
      })
    
  };
  const formValidation = (values) => {
    
    const errors = {};
    const mobRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    const aadharRegex =
      /(^[0-9]{4}[0-9]{4}[0-9]{4}$)|(^[0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|(^[0-9]{4}-[0-9]{4}-[0-9]{4}$)/;

   
    if (name == '') {
      errors.username = "Name is required";
    }
    if (startDate == '') {
      errors.startdate = "Date is required";
    }

    
    if (contactNumber == '') {
      errors.number = "Number is required";
    } else if (!mobRegex.test(contactNumber)) {
      errors.number = "Invalid Number";
    }
    if (adhaarNumber == '') {
      errors.aadharnumber = "Number is required";
    } else if (!aadharRegex.test(adhaarNumber)) {
      errors.aadharnumber = "Invalid Number";
    }
    if(branchId.length == 0){
      errors.branch = "Branch is required";
    }else if (
      !company||
      company == "Select Branch"
    ) {
      errors.company = "Branch is required";
    }
    if (company == '') {
      errors.company = "Company Name is required";
    } else if (
      !company||
      company == "Select Company"
    ) {
      errors.company = "Company Name is required";
    }
    if (state.length == 0) {
      errors.branch = "Branch Name is required";
    }
    console.log(state.length,state)
    if (officeAddress == '') {
      errors.officeadd = "Office Address is required";
    }


    return errors;
  };

  const handleSubmit = async (e) => {
    setLoading(true)
    e.preventDefault();
    setIsSubmit(true);
    const validate = await formValidation()
    setFormErrors(validate);
    setLoading(false)
    if (Object.keys(validate).length == 0) {
      registerApprover();
      
    }
  }
 

  return (
    <section className="lyt-section">
      {loading ? (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      ) : null}

      <Container fluid className="typ-container">
        <Breadcrumb className="bs-breadcrumb">
          <BreadcrumbItem>
            <NavLink to={`${directUrl}auditor/dashboard`}>Home</NavLink>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <NavLink to={`${directUrl}auditor/user-profile`}>
              User Profile
            </NavLink>
          </BreadcrumbItem>
          <BreadcrumbItem active>Approver</BreadcrumbItem>
        </Breadcrumb>
        <div className="bs-card typ-padding26">
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <Form className="bs-form">
                <Row className="bb-row">
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      <Label
                        for="examplePassword"
                        className="mr-sm-2 cstm-label"
                      >
                        Type of User
                      </Label>
                      <div className="select-option">
                        <Input
                          type="text"
                          name="text"
                          className="cstm-input"
                          id="exampleSelect"
                          value={'Approver'}
                          disabled
                        >
                        </Input>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      {' '}
                      <Label for="exampleEmail" className="mr-sm-2 cstm-label">
                        Name<span style={{color:'red'}}>*</span>
                      </Label>
                      <Input
                        type="text"
                        name="name"
                        id="exampleEmail"
                        className="cstm-input"
                        placeholder="Enter Your Name"
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                      />
                      <p className="error-message">{formErrors.username}</p>
                    </FormGroup>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      <Label for="examplecid" className="mr-sm-2 cstm-label">
                        Contact Number<span style={{color:'red'}}>*</span>
                      </Label>
                      <Input
                        type="text"
                        name="text"
                        id="examplecid"
                        className="cstm-input"
                        placeholder="Enter Contact Number"
                        onChange={(e) => {
                          setContactNumber(e.target.value);
                        }}
                      />
                      <p className="error-message">{formErrors.number}</p>
                    </FormGroup>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      <Label for="examplegst" className="mr-sm-2 cstm-label">
                        Aadhaar Number<span style={{color:'red'}}>*</span>
                      </Label>
                      <Input
                        type="text"
                        name="name"
                        id="examplegst"
                        className="cstm-input"
                        placeholder="Enter Aadhaar Number"
                        onChange={(e) => {
                          setAdhaarNumber(e.target.value);
                        }}
                      />
                      <p className="error-message">{formErrors.aadharnumber}</p>
                    </FormGroup>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      <Label
                        for="examplePassword"
                        className="mr-sm-2 cstm-label"
                      >
                        Date of Joining<span style={{color:'red'}}>*</span>
                      </Label>
                      <div className="calender-area">
                        <DatePicker
                          selected={startDate}
                          dateFormat={'yyyy-MM-dd'}
                          maxDate={new Date()}
                          onChange={(date) => setStartDate(date)}
                          placeholderText="Enter Date of Joining"
                        />
                      </div>
                      <p className="error-message">{formErrors.startdate}</p>
                    </FormGroup>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      <Label
                        for="examplePassword"
                        className="mr-sm-2 cstm-label"
                      >
                        Company<span style={{color:'red'}}>*</span>
                      </Label>
                      <div className="select-option">
                        <Input
                          className="typ-select"
                          type="select"
                          onChange={(e) => {
                            console.log('compnay', e.target.value);
                            handleCompany(e.target.value);
                          }}
                          name="select"
                          id="exampleSelect"
                        >
                          <option selected disabled>
                            Select Company<span style={{color:'red'}}>*</span>
                          </option>
                          {companyList.map((item) => (
                            <option>{item.company_name}</option>
                          ))}
                          {/* <option>HDFC</option>
                                                <option>2</option>
                                                <option>3</option>
                                                <option>4</option>
                                                <option>5</option> */}
                        </Input>
                        <p className="error-message">{formErrors.company}</p>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      <Label
                        for="examplePassword"
                        className="mr-sm-2 cstm-label"
                      >
                        Branch<span style={{color:'red'}}>*</span>
                      </Label>
                      <Select
                      isClearable={true}
                      id="branchMulti"
                        className="custom-multi-select"
                        options={options}
                        isMulti
                      filterOption={filterOption}
                      onInputChange={onInputChange}
                        onChange={(e) => {
                          console.log('multi ', e);
                          handleChangeSelect(e);
                        }}
                        value={state.values.length > 0 ? state.values : []}
                      >
                        
                        <options>{state.values}</options>
                      </Select>
                    </FormGroup>
                    <p className="error-message">{formErrors.branch}</p>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      <Label for="exampleText" className="cstm-label">
                        Office Address<span style={{color:'red'}}>*</span>
                      </Label>
                      <Input
                        type="textarea"
                        name="text"
                        className="cstm-input"
                        rows="5"
                        id="exampleText"
                        placeholder="Enter Office Address"
                        onChange={(e) => {
                          setOfficeAddress(e.target.value);
                        }}
                      />
                      <p className="error-message">{formErrors.officeadd}</p>
                    </FormGroup>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    <button
                      className="bs-btn btn-submit"
                      onClick={(e) => {
                        handleSubmit(e);
                      }}
                      type="button"
                    >
                      SUBMIT
                    </button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </Container>
    </section>
  );
}

export default Approver;
